import { Fade, Grow, Paper, Popper } from "@material-ui/core";
import * as React from "react";
import OutsideClickHandler from "react-outside-click-handler";
import { SUPPORT_EMAIL } from "../constants";
import "./Help.scss";
import HelpIcon from "./help.svg";

interface HelpState {
  open: boolean;
  anchorEl: HTMLElement | null;
}

export class Help extends React.Component<{}, HelpState> {
  constructor(props: {}) {
    super(props);

    this.state = { open: false, anchorEl: null };
  }

  public openMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({
      open: this.state.open ? false : true,
      anchorEl: event.currentTarget
    });
  };

  public closeMenu = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ open: false, anchorEl: null });
  };

  public render() {
    return (
      <OutsideClickHandler
        onOutsideClick={this.closeMenu}
        disabled={!this.state.open}
      >
        <div className="Help">
          <div className="Help__link" onClick={this.openMenu}>
            <img src={HelpIcon} />
          </div>

          <Popper
            open={this.state.open}
            anchorEl={this.state.anchorEl}
            placement={"top-end"}
            transition={true}
            className="Help__menu__container"
          >
            {({ TransitionProps }) => (
              <Grow {...TransitionProps} timeout={150}>
                <Fade {...TransitionProps} timeout={150}>
                  <Paper>
                    <div className="Help__menu">
                      <h1 className="Help__menu__header">Contact Support</h1>
                      <div className="Help__menu__body">
                        For help and to get in touch with the QUIQspread team,
                        email us at:
                      </div>
                      <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        className="Help__menu__link"
                      >
                        {SUPPORT_EMAIL}
                      </a>
                    </div>
                  </Paper>
                </Fade>
              </Grow>
            )}
          </Popper>
        </div>
      </OutsideClickHandler>
    );
  }
}

export default Help;



// WEBPACK FOOTER //
// ./src/topNav/Help.tsx